import { render, staticRenderFns } from "./MeasureHistory.vue?vue&type=template&id=27f38444&"
import script from "./MeasureHistory.vue?vue&type=script&lang=js&"
export * from "./MeasureHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports